export default function (context, {field, value}) {
    let data = {};
    data[field] = value;
    context.commit('data', data);
}